<template>
    <div id="app">
        <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center">
             <div style="float: left" class="puitre_list">
                 <!--   发布者信息1    -->
                 <div style="width: 100%;height: auto;float: left;display: flex;">
                     <div style="margin-left: 10px;width: 100%;">
                         <div style="width: 31px;height: 31px;float: left;">
                             <img :src="QuestionInfo.headIco" style="border-radius: 50%;width: 100%;height: 100%;margin-top: 13px;">
                         </div>
                         <div style="margin-top: 10px;display: flex;float: left">
<!--                             <div style="color: #2970FF;font-size: 14px;padding-top: 7px;line-height: 22px;">{{QuestionInfo.publisher}}</div>-->
                             <div style="max-width: 500px;clear: both;line-height: 35px;font-size: 20px;margin: 0px 10px 0 10px;font-weight: bold;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;cursor: pointer;" :title="QuestionInfo.typeStrName">{{QuestionInfo.title}}</div>
<!--                             <div style="margin-top:5px;height: 21px;margin-left: 10px;line-height: 30px;">-->
<!--                                 <div v-for="(item,List) in QuestionInfo.typeArrName" :key="List" style="font-size: 14px;color: #444444;float: left;">{{item}}<span v-if="List !== QuestionInfo.typeArrName.length - 1 ">></span></div>-->
<!--                             </div>-->
                             <div style="overflow: hidden;margin-top: 5px;">
                                 <el-tag v-if="QuestionInfo.rewardType == 1" size="small" type="danger" style="margin: 3px 10px;background: #f56c6c;color: #FFFFFF">红包问答</el-tag>
                                 <el-tag v-if="QuestionInfo.rewardType == 2" size="small" type="warning" style="margin: 3px 10px;background:#e6a23c;color: #FFFFFF">悬赏资料</el-tag>
                                 <el-tag v-if="QuestionInfo.rewardType == 3" size="small" type="success" style="margin: 3px 10px;background: #67c23a;color: #FFFFFF">悬赏讨论</el-tag>
                                 <el-tag v-if="QuestionInfo.rewardType == 4" size="small"  style="margin: 3px 10px;background: #409eff;color: #FFFFFF">比选竞标</el-tag>
                             </div>
                             <div v-if="QuestionInfo.rewardMoney > 0" style="display: flex;padding-top: 10px;">
                                 <div style="font-size: 16px;margin-left: 5px;">悬赏人数：<span style="color: #FF5E5E;font-size: 16px;margin-left: 2px;">{{QuestionInfo.rewardPeopleSum}}人</span></div>
                                 <div style="font-size: 16px;margin-left: 5px;">悬赏金额：</div>
                                 <div style="margin-left: 5px;">
                                     <img src="@/assets/imgs/index/release.png" style="width: 20px;height: 20px;">
                                 </div>
                                 <div style="color: #FF5E5E;font-size: 16px;margin-left: 5px;">{{QuestionInfo.rewardMoney}}<span style="color: #FF5E5E;font-size: 16px;margin-left: 2px;">元</span></div>
                             </div>
                             <div v-if="QuestionInfo.roomId > 0" style="height: 21px;margin-top: 10px;margin-left: 5px;">
                                 <div style="float: left;margin-top: 2px">
                                     <img src="@/assets/imgs/index/house.png" style="width: 16px;height: 16px;">
                                 </div>
                                 <div style=" max-width: 150px;height: 19px;font-size: 16px;color: #031F88;float: left;margin: 0px 6px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{QuestionInfo.roomName}}</div>
                             </div>
                             <div v-if="QuestionInfo.isReward == 1 && QuestionInfo.expiredNot == 0 && QuestionInfo.isPenny == 0" style="padding-top: 10px;overflow: hidden;color: #409EFF;padding-left: 5px;">
                                 <span>距结束：</span>
                                 <span>{{ countdownInfo.days }}</span> 天
                                 <span>{{ countdownInfo.hours }}</span> 小时
                                 <span>{{ countdownInfo.minutes }}</span> 分钟
                                 <span>{{ countdownInfo.seconds }}</span> 秒
                             </div>
                             <div style="overflow: hidden;margin-top: 5px;margin-left: 5px;">
                                 <el-tag v-if="QuestionInfo.expiredNot == 1" size="small" type="success" style="margin: 3px 10px;background: #c1c1c1;color: #FFFFFF;">已过期</el-tag>
                             </div>
                             <div style="overflow: hidden;margin-top: 5px;">
                                 <el-tag v-if="QuestionInfo.expiredNot == 1 && QuestionInfo.payStatus == 1 && QuestionInfo.isPenny == 0 && reviewCount == 0" size="small" type="success" style="margin: 3px 10px;background: red;color: #FFFFFF;">未退款</el-tag>
                             </div>
                             <div style="overflow: hidden;margin-top: 5px;">
                                 <el-tag v-if="QuestionInfo.expiredNot == 1 && QuestionInfo.payStatus == 2 && QuestionInfo.isPenny == 0" size="small" type="success" style="margin: 3px 10px;background: red;color: #FFFFFF;">已退款</el-tag>
                             </div>

                             <div style="overflow: hidden;margin-top: 5px;">
                                 <el-tag v-if="QuestionInfo.payStatus == 1 && QuestionInfo.isPenny == 0" size="small" type="success" style="margin: 3px 10px;background: #FF9800;color: #FFFFFF;">暂未分账</el-tag>
                             </div>
                             <div style="overflow: hidden;margin-top: 5px;">
                                 <el-dropdown @command="handleClick">
                                      <span class="el-dropdown-link">
                                        <el-tag v-if="QuestionInfo.payStatus == 1 && QuestionInfo.isPenny == 1" size="small" type="success" style="margin: 3px 10px;background: #FF9800;color: #FFFFFF;">已分账<i class="el-icon-arrow-down el-icon--right"></i></el-tag>
                                      </span>
                                     <el-dropdown-menu slot="dropdown">
                                         <el-dropdown-item command="bonus">分账明细</el-dropdown-item>
                                     </el-dropdown-menu>
                                 </el-dropdown>
                             </div>
                             <div style="color: #999999;padding-top: 8px;font-size: 16px;">回答{{reviewCount}}条</div>
                             <div style="margin-top: 7px">
                                 <el-divider direction="vertical"></el-divider>
                             </div>
                             <div style="color: #FF9800;padding-top: 8px;font-size: 16px;">采纳{{IsAdoptCount}}条</div>
                         </div>
                         <div v-if="is_login == 1 && reviewCount == 0 && QuestionInfo.uuid == me.uuid" style="width: 30px;float: right;line-height: 35px;margin-top: 10px;">
                            <el-dropdown @command="more_action" >
                                 <span class="el-dropdown-link">
                                   <i class="el-icon-caret-bottom" style="font-size: 24px"></i>
                                 </span>
                                  <el-dropdown-menu slot="dropdown" >
                                      <label >
                                          <el-dropdown-item v-if="QuestionInfo.rewardType  == 1" command="delete">删除红包问答</el-dropdown-item>
                                          <el-dropdown-item v-if="QuestionInfo.rewardType  == 2" command="delete">删除悬赏资料</el-dropdown-item>
                                          <el-dropdown-item v-if="QuestionInfo.rewardType  == 3" command="delete">删除悬赏讨论</el-dropdown-item>
                                          <el-dropdown-item v-if="QuestionInfo.rewardType  == 4" command="delete">删除比选竞标</el-dropdown-item>
                                      </label>
                                  </el-dropdown-menu>
                            </el-dropdown>
                         </div>
                     </div>
                 </div>

                 <div style="width: 100%;height: auto;">
                     <div  style=" width: calc(100% - 10px);padding-left: 10px; float: left; margin-top: 10px;margin-bottom:10px;white-space: pre-wrap;" v-html="QuestionInfo.content"></div>
                     <!--   循环视频   -->
                     <div v-if="QuestionInfo.videos != null && QuestionInfo.videos.length>0" style="width: 587px;height: auto;margin-left: 10px;margin-top: 10px;" >
                         <label v-if="QuestionInfo.videos.length>0" @click="look">
                             <div v-for="(it,index) in QuestionInfo.videos" :key="index" style="margin-left: 10px;position: relative;">
                                 <img :src="it.url+'?x-oss-process=video/snapshot,t_0,f_jpg'" style="width: 100%;height:100%;object-fit: cover;border-radius: 5px">
                                 <img class="centered-image"  src="https://baigongbao.oss-cn-beijing.aliyuncs.com/assets/index/menu/hongbao/icon13.png">
                             </div>
                         </label>
                     </div>

                     <!--   循环图片 @click="lookcode(index)"   -->
                     <div  v-if="QuestionInfo.images && QuestionInfo.images.length > 0" style="margin-left: 10px;">
                         <div style="display: flex; flex-wrap: wrap; width: 100%;">
                             <div  v-for="(i,idx) in QuestionInfo.images" :key="idx">
                                 <div style="width: 350px;height: 350px; margin-right: 10px; margin-bottom: 10px;background: #aa7700;">
                                     <!-- 图片1 -->
                                     <el-image  style="width: 100%; height: 100%;" :src="i['url']" :preview-src-list="[i['url']]"></el-image>
                                 </div>
                             </div>
                         </div>
                     </div>

                     <!--      发布的附件   -->
                     <div style="clear: both">
                         <div v-if="QuestionInfo.files && QuestionInfo.files.length >0">
                             <div v-for="(item,index) in QuestionInfo.files" :key="index">
                                 <div style="display:inline-block;padding-top: 10px;margin-left: 10px;">
                                     <span style="padding-top: 10px;"> <svg style="padding-top: 10px" t="1681188831011" class="fuGian" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5155" width="30" height="23"><path d="M881.371429 362.057143v570.514286c0 25.6-18.285714 43.885714-43.885715 43.885714H186.514286c-25.6 0-43.885714-18.285714-43.885715-43.885714v-841.142858c0-25.6 21.942857-43.885714 43.885715-43.885714h431.542857l263.314286 314.514286zM841.142857 365.714286l-223.085714-266.971429L621.714286 329.142857c0 25.6 14.628571 40.228571 29.257143 40.228572L841.142857 365.714286z m-256-285.257143H186.514286c-7.314286 0-10.971429 3.657143-10.971429 10.971428v844.8c0 7.314286 3.657143 10.971429 10.971429 10.971429h650.971428c7.314286 0 10.971429-3.657143 10.971429-10.971429V402.285714h-197.485714c-36.571429 0-62.171429-32.914286-62.171429-73.142857L585.142857 80.457143z" fill="#BEC3CC" p-id="5156"></path><path d="M881.371429 501.028571H142.628571c-18.285714 0-29.257143 7.314286-29.257142 25.6V841.142857c0 14.628571 10.971429 25.6 29.257142 25.6h742.4c18.285714 0 29.257143-7.314286 29.257143-25.6v-318.171428c-3.657143-14.628571-10.971429-21.942857-32.914285-21.942858z m-548.571429 259.657143h-14.628571v-7.314285c-3.657143-7.314286-3.657143-14.628571-3.657143-18.285715H329.142857c10.971429 0 14.628571-7.314286 14.628572-18.285714 0-14.628571-7.314286-32.914286-18.285715-51.2l18.285715-69.485714h-29.257143v204.8h-25.6v-230.4H365.714286v25.6l-18.285715 65.828571c14.628571 18.285714 18.285714 36.571429 18.285715 58.514286 0 25.6-10.971429 36.571429-32.914286 40.228571z m76.8-146.285714v186.514286h-25.6V658.285714c0 3.657143-3.657143 7.314286-7.314286 10.971429-3.657143 3.657143-7.314286 10.971429-7.314285 10.971428 0-3.657143-3.657143-10.971429-3.657143-18.285714 0-3.657143-3.657143-10.971429-3.657143-10.971428 18.285714-29.257143 32.914286-58.514286 40.228571-91.428572l25.6 3.657143c-3.657143 10.971429-7.314286 25.6-18.285714 43.885714v7.314286z m113.371429 25.6h-21.942858v120.685714c0 25.6-10.971429 36.571429-32.914285 36.571429H438.857143c0-10.971429-3.657143-18.285714-3.657143-25.6h25.6c14.628571 0 18.285714-3.657143 18.285714-18.285714v-117.028572h-51.2v-25.6h51.2v-51.2h25.6v51.2h21.942857v29.257143z m-106.057143 25.6l21.942857-7.314286c7.314286 18.285714 18.285714 36.571429 25.6 51.2l-21.942857 10.971429c-7.314286-18.285714-18.285714-36.571429-25.6-54.857143z m171.885714 135.314286h-25.6v-128c-7.314286 10.971429-14.628571 25.6-25.6 36.571428-3.657143-14.628571-3.657143-25.6-7.314286-36.571428 18.285714-29.257143 36.571429-65.828571 47.542857-109.714286l25.6 7.314286c-3.657143 18.285714-10.971429 36.571429-18.285714 51.2v179.2z m190.171429-80.457143h-62.171429v76.8h-25.6v-76.8h-84.114286V694.857143h84.114286v-54.857143h-40.228571c-3.657143 14.628571-10.971429 29.257143-14.628572 40.228571-3.657143-3.657143-10.971429-3.657143-18.285714-7.314285-3.657143 0-3.657143 0-3.657143-3.657143 10.971429-25.6 21.942857-54.857143 29.257143-95.085714l25.6 3.657142c-3.657143 10.971429-3.657143 21.942857-7.314286 32.914286h32.914286v-54.857143h25.6v54.857143h54.857143v25.6h-54.857143V694.857143h62.171428v25.6z" fill="#0090FF" p-id="5157"></path></svg></span>
                                     <span style="width:auto;color: #1a1a1a;margin-left:5px;font-size: 20px;display:inline-block; overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">{{item.name}}</span>
                                     <div style="color: #f56c6c;display:inline-block;margin-left: 10px;cursor:pointer;font-size: 18px;overflow: hidden" @click="download1(item['url'],item['name'],item['hash'])">下载</div>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>

                 <div style="width: calc(100% - 10px);line-height: 30px;text-align: right;margin-right: 10px;font-size: 12px;">发布日期：{{QuestionInfo.createTime}}  浏览量{{QuestionInfo.clickCount}}</div>
                 <div v-if="is_login === 1" style="width: calc(100% - 10px);line-height: 30px;margin-left: 10px;font-size: 12px;font-weight: bold;">请写下你的评论</div>
              </div>
        </div>
        <!--     视频弹窗    -->
        <el-dialog :close-on-click-modal="false" v-if="QuestionInfo.videos != null && QuestionInfo.videos.length>0" :visible.sync="dialogVisible" width="50%">
            <video-player class="video-player vjs-custom-skin" id="videoPlayer" ref="videoPlayer" :playsinline="true" :options="videoOptions(QuestionInfo.videos[0].url,QuestionInfo.videos[0].url+'?x-oss-process=video/snapshot,t_0,f_jpg')" ></video-player>
        </el-dialog>
        <!--     图片弹窗    -->
        <el-dialog :close-on-click-modal="false"  :visible.sync="Visible" >
            <div style="float: left;height: auto">
                <div v-if="QuestionInfo.images && QuestionInfo.images.length>0">
                     <img :src="QuestionInfo.images[0].url"  style="width: 100%;height:50%;margin-left: 10px;float: left;margin-bottom: 10px;">
                </div>
            </div>
        </el-dialog>
        <!--     发布回答    -->
       <div v-if="is_login === 1">
           <div v-if="show" style="display: flex;justify-content: center">
               <Comment :data="QuestionInfo" ></Comment>
           </div>
       </div>
        <!--     分账明细    -->
        <el-dialog :close-on-click-modal="false"  :visible.sync="bonus" >
          <template>
            <el-table
                :data="bonusInfo"
                style="width: 100%">
              <el-table-column
                  prop="name"
                  label="分红者"
                  width="180">
              </el-table-column>
              <el-table-column
                  prop="amount"
                  label="分红金额(元)"
                  width="180">
              </el-table-column>
              <el-table-column
                  prop="isPenny"
                  label="是否结算">
              </el-table-column>
            </el-table>
              <div style="width: 100%;height: 35px;">
                    <div @click="b('/index/help/16')" style="width: auto;line-height: 35px;float: right;color: blue;cursor: pointer;">了解分红规则</div>
              </div>
          </template>
        </el-dialog>
    </div>
</template>

<script>
import Comment from "./comment"
export default {
    components:{
        Comment
    },
    computed: {
        me() {
            return this.$store.state.user
        },
        is_login(){
            return this.$store.state.is_login
        }
    },
    watch:{
        QuestionInfo(newValue, oldValue){
            console.log('contentPage data 发生变化：', newValue);
            this.reviewAndIsAdopt();
            this.init();
        }
    },
    props: {
        QuestionInfo: {
            type: Object,
            default(){
                return { }
            }
        }
    },
    data () {
        return {
            playerOptions: {},
            videos:[],
            images:[],
            dialogVisible:false,
            Visible:false,
            show:true,
            release:"我来回答",
            color:"",
            rewardTypeList: [
                { type: '', label: '' },
                { type: 'success', label: '红包问答' },
                { type: 'info', label: '悬赏资料' },
                { type: 'danger', label: '悬赏讨论' },
                { type: 'warning', label: '比选竞标' }
            ],
            bonus:false,
            bonusInfo:[],
            countdownInfo:{days : 0,hours : 0,minutes : 0,seconds : 0},
            reviewCount:0,
            IsAdoptCount:0,
        }
    },
    created:function(){

    },
    mounted:function(){
      var that = this;
      setTimeout(()=>{that.startCountdown();},1000);
      //监听支付成功回调
      this.$EventBus.$on("payMsg", (data) => {
        this.$nextTick(() => {
          if (data.code == 100) {
            that.deleteQuestion()
          }
        });
      });
    },
    methods:{
      //计算回答及采纳数量
      reviewAndIsAdopt() {
        var that = this;
        that.reviewCount = that.QuestionInfo.reviewCount.length;
        that.IsAdoptCount = 0;
        for (let i = 0; i < that.QuestionInfo.reviewCount.length; i++) {
          if (that.QuestionInfo.reviewCount[i].isAdopt == 1) {
              that.IsAdoptCount++;
          }
        }
      },

       //倒计时
        startCountdown(){
          var that = this;
          if(that.QuestionInfo.isReward == 1 && that.QuestionInfo.expiredNot == 0){
              that.countdownInfo = that.utils.countdown(that.QuestionInfo.endTime);
              // 使用 setTimeout 让 updateCountdown 每秒执行一次
              setTimeout(() => {
                that.countdownInfo = that.utils.countdown(that.QuestionInfo.endTime);
                // 再次调用 startCountdown，以便每秒钟都执行 updateCountdown
                this.startCountdown();
              }, 1000);
          }
        },

        //分账明细
        handleClick(e){
          var that = this;
            if(e == "bonus"){
                //获取分账明细
                that.newApi.getBonusDetail({id:that.QuestionInfo.id}).then((res)=>{
                    if(res.isSuccess == 1){
                        that.bonus = true;
                        that.bonusInfo = res.data;
                    }
                })
            }
        },

        //下拉菜单触发的方法
        more_action:function(e){
          var that = this;
          var msg = "确定删除吗？";

          if(that.QuestionInfo.isReward == 1 && that.QuestionInfo.payStatus == 1){
            msg = "已开启悬赏删除后金额将原路返回,确定删除吗？"
          }
          if(e == "delete"){
            that.utils.confirm(msg,()=>{
              that.deleteQuestion();
            })
          }
        },

        //删除提问
        deleteQuestion(){
          var that = this;
          that.newApi.deleteQuestion({id:that.QuestionInfo.id}).then((res)=>{
            if(res.isSuccess == 1){
              if(res.data.code == 1){
                that.utils.sus(res.data.msg);
              }else if(res.data.code == 2){
                that.openLoading(res.data.msg);
                var params = {};
                params.paymentId = res.data.paymentId;
                params.reverseAmt = res.data.payAmt;
                that.newApi.paymentReverseIndividual(params).then(() =>{
                    that.utils.sus("退款成功!");
                })
              }else if(res.data.code == 3){
                that.utils.sus(res.data.msg);
                that.closeLoading();
                that.$EventBus.$off("payMsg");
              }
              if(that.QuestionInfo.roomId > 0){
                  that.$router.push({path: '/room/info/' + that.QuestionInfo.roomId});
              }else{
                that.$router.push({path: '/'});
              }
              if(that.QuestionInfo.roomId > 0){
                  that.$router.push({path: '/room/info/' + that.QuestionInfo.roomId});
              }else{
                  that.$router.push({path: '/'});
              }

            }
          })
        },

        init(){
            var that = this;
            for (let i = 0; i< that.QuestionInfo.videos.length;i++){
                that.playerOptions = {
                    playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                    autoplay: false, // 如果为true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 是否视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "video/mp4", // 类型
                        src: that.QuestionInfo.videos[i].url// url地址
                    }],
                    poster: that.QuestionInfo.videos[i].url, // 封面地址
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true, // 当前时间和持续时间的分隔符
                        durationDisplay: true, // 显示持续时间
                        remainingTimeDisplay: false, // 是否显示剩余时间功能
                        fullscreenToggle: true // 是否显示全屏按钮
                    }
                }
            }
        },
        cache(){
            var that = this;
            that.show = !this.show;
            // this.show = true;
        },
        // 视频弹窗事件
        look(){
            var that = this;
            if (that.QuestionInfo.images == "" && that.QuestionInfo.videos == "" && that.QuestionInfo.files == ""){
                that.utils.err("没有上传多媒体格式、无法查看");
                return false;
            }else {
                that.dialogVisible = true;
            }
        },
        // 下载附件事件
        download1 (url,name,hash){
            var that = this;
            if(that.me.realNameStatus == 0 || that.me.realNameStatus == 1){
                that.utils.err("只有实名认证后才能下载素材");
                that.$router.push({path: '/circle/mySpace/'+that.user.uuid, query: {realNameAuth: that.user.realNameStatus}});
            }else {
                this.utils.download(url,name,hash)
            }
        },
        videoOptions(url,img){
            //不公开 判断发布者与自己可以听到语音muted = true 否则无语音 muted = false
            console.log(url)
            var muted = false;
            var obj = {
                muted:muted,  //是否静音
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                aspectRatio: '16:9',
                sources: [{
                    src:url
                }],
                fluid: true,
                poster:img,
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: true,
                    fullscreenToggle: true  //全屏按钮
                }
            }
            return obj;
        },
    }
}

</script>
<style scoped>
/deep/ .el-dialog {
    height: auto;
    overflow: hidden;
    /*background-color:transparent;*/
    /*box-shadow: 0 0px 0px rgba(0,0,0,.3);*/
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
    color: red;
    font-size: 35px;
}

/*/deep/ .el-carousel__button {*/
/*     background-color: red;*/
/*     padding-top: 20px !important;*/
/* }*/

.puitre_list {
    background: #FFFFFF;
    overflow: hidden;
    width: 1500px;
    border-radius: 5px 5px 5px 5px;
    height: auto;
}
.puitre_code {
    background: #FFFFFF;
    overflow: hidden;
    width: 913px;
    border-radius: 5px 5px 5px 5px;
    height: auto;
}
.tld {
    width: 1450px;
    font-size: 16.5px;
    margin-left: 30px;
    color: #444444;
    line-height:25px;
    text-shadow: #444444;
    text-align: left;
}
.titlecode {
    width:96%;
    height: 40px;
    font-size: 19px;
    margin-left: 30px;
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; color: #444444
}
.answerold {
    float: right;
    margin-right: 30px;
    padding-top: 25px;
}
.answernow {
    float: right;
    margin-right: 20px;
    padding-top: 30px;
}
.type_list {
    margin-left: 30px;
}
.centered-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
}
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
}
.el-icon-arrow-down {
    font-size: 12px;
}
</style>
